import React from "react";
import "../styleSheet/Nav.css";
import img3 from "../images/icon.png";
import { useNavigate } from "react-router-dom";

export default function Nav() {
  const navigate = useNavigate();
  const redirectHome = () => {
    navigate("/");
  };

  return (
    <div>
      <nav class='navbar bg-body-tertiary myNav'>
        <div class='container-fluid'>
          <a class='navbar-brand mb-0 h1 navText' href='/'>
            &nbsp; &nbsp;
            <strong>
              <span style={{ fontFamily: 'Caveat, cursive',color: "#3052a4",  fontSize: "21px"}}>CV</span>
              <span style={{ fontFamily: 'Playfair Display', fontWeight: 'normal', color:"red", fontSize :"19px"}}>Tuner </span>
            </strong>
              <span style={{fontSize:"13px", color :"#3153a5"}}>by</span>
            <img src={img3} style={{marginBottom : "2px"}} class='logoImg' />
          </a>
        </div>
      </nav>
    </div>
  );
}
